module.exports = __webpack_public_path__ + "assets/img/conversion.0ff7734e.png";